const autoNgTemplateLoaderTemplate1 = require('./ssl-ca-file-settings.html');

import controller from './ssl-ca-file-settings-controller.js';

export const sslCaFileSettings = {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller,
};
